import React from "react"
import SiteNavigation from '../components/siteNavigation'
import pkc from '../images/pkc.gif'

export default () =>
    <SiteNavigation>
        <img src={pkc} style={{outline: '2px solid white', outlineOffset: '-2px'}} />
        
    </SiteNavigation>



// WEBPACK FOOTER //
// ./src/pages/bio.js